import React, { useState, useEffect } from 'react';
import request from '../../../request';
import SPBreadcrumb from '../../../components/base/SPBreadcrumb';
import SearchForm from '../../../components/carRental/vehicleManagement/SPVehicleCalendarSearchFormNew';
import SPOccupyCalendar from '../../../components/carRental/vehicleManagement/SPOccupyCalendarNew';
import SPOccupyModal from '../../../components/carRental/vehicleManagement/SPOccupyModal';
import SPContentWrap from "../../../components/carRental/base/SPContentWrap";
import CarPlatoonModal from '../../../components/order-management/order-list/modals/car-platoon-modal';


interface PagePropsType {
	enums?: any;
	permission?: any;
}
const Page: React.FC<PagePropsType> = props => {
	const { enums, permission } = props;

	return (
		<>
			<SPBreadcrumb title="库存日历" />
			<SPContentWrap className='common-margin-top'>
				<SearchForm />
			</SPContentWrap>
			<SPOccupyCalendar enums={enums} permission={permission}/>
			<SPOccupyModal enums={enums} />
			<CarPlatoonModal enums={enums}></CarPlatoonModal>
		</>
	);
};

export default Page;
